const deepSearch = (obj, key, val) => {
  let results = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const k in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(k)) {
      // eslint-disable-next-line security/detect-object-injection
      if (k === key && obj[k] === val) {
        results.push(obj);
        // eslint-disable-next-line security/detect-object-injection
      } else if (typeof obj[k] === 'object') {
        // eslint-disable-next-line security/detect-object-injection
        results = results.concat(deepSearch(obj[k], key, val));
      }
    }
  }
  return results;
};

module.exports = deepSearch;
